import type { App } from 'vue'
import { createVfm } from 'vue-final-modal'

export function installModal(app: App) {
  const vfm = createVfm()
  app.use(vfm)
}
